// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"109":"770f7d72","344":"e976950c","375":"2b4b1ed5"}[chunkId] + ".chunk.js";
};